export default "__VITE_ASSET__IKFGCRJd__"